export default __webpack_public_path__ + "static/ssr-d5b295a2d733ad4803f44aca1384e805.svg";